module.exports = __webpack_public_path__ + "img/Accessibility-settings_De.84edc0f2.png";